export default "__VITE_ASSET__200faa5f__"